import * as React from "react";

const SvgIcon = ({ size = '64', color = '#f9a928' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 64 64"
  >
    <path
      fill={color}
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.865"
      d="M31.986 20.337c-6.417 0-11.663 5.246-11.663 11.663s5.246 11.663 11.663 11.663c6.418 0 11.663-5.246 11.663-11.663s-5.245-11.663-11.663-11.663m0 4A7.633 7.633 0 0 1 39.65 32a7.633 7.633 0 0 1-7.663 7.663A7.633 7.633 0 0 1 24.324 32a7.633 7.633 0 0 1 7.662-7.663m0-13.95c-14.19 0-26.389 8.553-31.633 20.76L-.014 32l.367.853c5.244 12.207 17.443 20.76 31.633 20.76s26.39-8.554 31.634-20.76l.366-.853-.366-.853c-5.245-12.206-17.443-20.76-31.634-20.76m0 4.322c12.109 0 22.448 7.112 27.22 17.291-4.772 10.179-15.111 17.29-27.22 17.29S9.54 42.18 4.766 32c4.773-10.179 15.112-17.29 27.22-17.29"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;

